module.exports = __webpack_public_path__ + "img/zflogo1.04223437.png";